// Class: openfl.display.IGraphicsPath

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IGraphicsPath = function() {}

// Meta

IGraphicsPath.__name__ = "openfl.display.IGraphicsPath";
IGraphicsPath.__isInterface__ = true;
IGraphicsPath.prototype = {
	
};
IGraphicsPath.prototype.__class__ = IGraphicsPath.prototype.constructor = $hxClasses["openfl.display.IGraphicsPath"] = IGraphicsPath;

// Init



// Statics




// Export

exports.default = IGraphicsPath;